/* Créaroma V9 — genuine Shopify size variants and per-EAN specs. */
(() => {
 function init() {
  const root=document.querySelector('[data-cr2-pdp]');
  if(!root || root.dataset.crearomaV9Ready)return;
  root.dataset.crearomaV9Ready='true';
  const $=s=>root.querySelector(s);
  const $$=s=>[...root.querySelectorAll(s)];
  const input=$('[data-cr2-pdp-qty]');
  const main=$('[data-cr2-primary-buy]');
  const sticky=$('[data-cr2-sticky-buy]');
  const select=$('[data-cr2-variant-select]');
  const price=$('[data-cr2-variant-price]');
  const stickyPrice=$('[data-cr2-sticky-price]');
  const stockMessage=$('[data-cr2-stock-message]');
  const extraStatus=$('[data-cr2-extra-status]');
  const gallery=$('[data-cr2-gallery]');
  const visual=$('[data-cr2-format-preview]');
  const buttons=$$('[data-cr2-weight-option]');

  const plainNumber=str=>Number.parseInt(String(str||''),10)||0;
  if(input){
   const fix=val=>Math.max(1,Math.min(99,plainNumber(val)||1));
   function refresh(){input.value=fix(input.value);const minus=$('[data-cr2-pdp-step="-1"]'),plus=$('[data-cr2-pdp-step="1"]');if(minus)minus.disabled=Number(input.value)<=1;if(plus)plus.disabled=Number(input.value)>=99;}
   $$('[data-cr2-pdp-step]').forEach(button=>button.addEventListener('click',()=>{input.value=fix(Number(input.value)+Number(button.dataset.cr2PdpStep));refresh();input.dispatchEvent(new Event('change',{bubbles:true}));}));
   input.addEventListener('change',refresh);
   input.addEventListener('blur',refresh);
   refresh();
  }
  function content(selector,value){const el=$(selector);if(el&&value!=null)el.textContent=value;}
  function setWeight(button){
   if(!button||!select)return;
   const val=button.dataset;
   // The current variant id belongs to Shopify; its value is what the native product form submits.
   select.value=val.variantId.split('/').pop();
   const available=val.variantAvailable==='true';
   const uncertain=val.variantSpecUncertain==='true';
   const isBaseFormat=val.variantName==='300 g';
   buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   content('[data-cr2-selected-weight]',val.variantName);
   content('[data-cr2-title-weight]',' · '+val.variantName);
   content('[data-cr2-h1-weight]',' · '+val.variantName);
   content('[data-cr2-spec-weight]',val.variantName);
   content('[data-cr2-spec-portions]',uncertain?'À confirmer':val.variantPortions+' portions');
   content('[data-cr2-spec-creatine]',uncertain?'À confirmer':val.variantCreatine+' g de créatine');
   content('[data-cr2-serving-label]',uncertain?'Informations du lot à vérifier':'Pour une portion de '+val.variantServing+' g de poudre');
   const verifiedDetails=$('[data-cr2-verified-details]'),uncertainDetails=$('[data-cr2-uncertain-details]');
   if(verifiedDetails)verifiedDetails.hidden=uncertain;
   if(uncertainDetails)uncertainDetails.hidden=!uncertain;
   content('[data-cr2-detail-weight]',val.variantName);
   content('[data-cr2-detail-portions]',val.variantPortions+' portions');
   content('[data-cr2-detail-creatine]',val.variantCreatine+' g de créatine');
   content('[data-cr2-detail-serving]',val.variantServing);
   content('[data-cr2-kf-weight]',val.variantName);
   content('[data-cr2-kf-portions]',uncertain?'Portions à confirmer':val.variantPortions+' portions');
   content('[data-cr2-kf-creatine]',uncertain?'Dosage à confirmer':val.variantCreatine+' g de créatine par portion');
   content('[data-cr2-art-weight]',val.variantName);
   content('[data-cr2-sticky-weight]',' · '+val.variantName);
   if(price)price.textContent=val.variantPrice;
   const compare=$('[data-cr2-compare-price]');
   if(compare){
     const valid=val.variantValidCompare==='true'&&Boolean(val.variantComparePrice);
     compare.hidden=!valid;
     compare.textContent=valid?val.variantComparePrice:'';
   }
   const salePct=$('[data-cr2-sale-percent]');
   if(salePct){
     const pct=Number.parseInt(val.variantDiscountPct||'0',10)||0;
     const valid=val.variantValidCompare==='true'&&pct>0;
     salePct.hidden=!valid;
     salePct.textContent=valid?'−'+pct+' %':'';
   }
   if(stickyPrice)stickyPrice.textContent=val.variantPrice;
   if(main){main.disabled=!available;main.setAttribute('aria-disabled',String(!available));}
   if(sticky){const b=sticky.querySelector('button[type="submit"]');if(b)b.disabled=!available;}
   content('[data-cr2-buy-label]',available?'Ajouter au panier':'Format indisponible');
   if(stockMessage)stockMessage.hidden=available;
   if(visual){
     const officialImage=visual.querySelector('[data-cr2-official-pack-img]');
     const realPhoto=Boolean(val.variantImage);
     visual.hidden=isBaseFormat;
     visual.classList.toggle('cr2-v10-real-photo',realPhoto);
     if(officialImage){
       officialImage.hidden=!realPhoto;
       if(realPhoto){officialImage.src=val.variantImage;officialImage.alt='Sachet OstroVit '+root.querySelector('.cr2-pdp-mobile-lead-name strong')?.textContent.trim().replace(/\s+\d+\s*(g|kg)$/i,'')+' · '+val.variantName;}
       else officialImage.removeAttribute('src');
     }
   }
   if(gallery){gallery.classList.toggle('cr2-v9-format-mode',!isBaseFormat);if(gallery.querySelector('[data-cr2-gallery-thumb]'))gallery.querySelector('[data-cr2-gallery-thumb]').click();}
   const note=$('[data-cr2-other-format-notice]'),desc=$('[data-cr2-description-original]');
   if(note)note.hidden=isBaseFormat;
   if(desc)desc.hidden=!isBaseFormat;
   root.querySelectorAll('[data-cr2-format-description]').forEach(block=>{
     block.hidden=block.getAttribute('data-cr2-format-description')!==val.variantName;
   });
  }
  if(select && buttons.length) {
   buttons.forEach(b=>b.addEventListener('click',()=>setWeight(b)));
   const requested=buttons.find(b=>b.dataset.variantId.endsWith('/'+select.value));
   const chosen=(requested?.dataset.variantAvailable==='true'?requested:null)||
     buttons.find(b=>b.dataset.variantAvailable==='true')||buttons[0];
   setWeight(chosen);
   const selector=$('[data-cr2-select-fallback]');if(selector)selector.hidden=true;
   const choices=$('[data-cr2-weight-choices]');if(choices)choices.hidden=false;
   root.classList.add('cr2-weight-ready');
   select.addEventListener('change',()=>{const found=buttons.find(b=>b.dataset.variantId.endsWith('/'+select.value)&&b.dataset.variantAvailable==='true');if(found)setWeight(found);});
  }
  if(sticky && main){
   const syncSticky=()=>{
    const r=main.getBoundingClientRect();
    const above=r.bottom<=10;
    const below=r.top>=window.innerHeight-115;
    sticky.hidden=!(window.innerWidth<=750 && window.scrollY>95 && (above||below));
   };
   window.addEventListener('scroll',syncSticky,{passive:true});
   window.addEventListener('resize',syncSticky,{passive:true});
   syncSticky();
  }
  const rootUrl=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
  $$('.cr2-quick-crosssell-form').forEach(form=>form.addEventListener('submit',async event=>{
   if(!window.fetch||!window.FormData)return;
   const id=form.querySelector('[name="id"]')?.value;
   if(!id)return;
   event.preventDefault();
   const btn=form.querySelector('button[type="submit"]'),original=btn?.textContent||'+ Ajouter';
   if(btn){btn.disabled=true;btn.textContent='Ajout…';}
   if(extraStatus){extraStatus.hidden=true;extraStatus.textContent='';extraStatus.classList.remove('is-error');}
   try{
    const res=await fetch(rootUrl+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
    const d=await res.json().catch(()=>({}));
    if(!res.ok)throw Error(d.description||d.message||"Impossible d'ajouter cette saveur.");
    if(extraStatus){extraStatus.hidden=false;extraStatus.textContent='Saveur ajoutée au panier. ';const a=document.createElement('a');a.href=rootUrl+'cart';a.textContent='Voir mon panier ↗';extraStatus.appendChild(a);}
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('crearoma:added',{detail:{variantId:Number(id)}}));
   }catch(e){if(extraStatus){extraStatus.hidden=false;extraStatus.classList.add('is-error');extraStatus.textContent=e?.message||'Ajout impossible, réessaie.';}}
   finally{if(btn){btn.disabled=false;btn.textContent=original;}}
  }));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
})();